import { render } from "./PreventClickResourceTable.vue?vue&type=template&id=78db0152"
import script from "./PreventClickResourceTable.vue?vue&type=script&lang=js"
export * from "./PreventClickResourceTable.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Programs\\Projects\\www\\cae-new-web\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"PreventClickResourceTable.vue"]])

export default __exports__